module.exports = __webpack_public_path__ + "static/media/academy_500.387f87ca.jpg";